(ns ^:dev/always bp-clients.tv-app.nav.adapters.menu
  "Namespace for all navigation adapters"
  (:require
   [bp-libs.design-system.components.icons :refer [home film search log-out tv stars school toy diamond certified]]))

(defn- adapted-data [menu-item]
  (assoc menu-item
         :text (:label menu-item)
         :id (-> menu-item :page_id keyword)))

(defn- adapted-icon [menu-item]
  (case (-> menu-item :icon :svg_id)
    "icons/home"      (assoc menu-item :icon [home])
    "icons/film"      (assoc menu-item :icon [film])
    "icons/tv"        (assoc menu-item :icon [tv {:variant :a}])
    "icons/stars"     (assoc menu-item :icon [stars])
    "icons/school"    (assoc menu-item :icon [school])
    "icons/toy"       (assoc menu-item :icon [toy])
    "icons/certified" (assoc menu-item :icon [certified])
    (assoc menu-item :icon [diamond])))

(def ^:private default-menu-items
  {:search    {:icon  [search]
               :id    :search
               :page_id "search"
               :text  "Pesquisar"
               :index 0}
   :logout    {:icon  [log-out]
               :id    :logout
               :text  "Sair"
               :index 100}})

(defn menu-items-map [api-menu-items]
  (let [adapted-api-menu-items (reduce (fn [acc item]
                                         (assoc acc
                                                (-> item :page_id keyword)
                                                ((comp adapted-icon adapted-data) item)))
                                       {}
                                       api-menu-items)
        all-menu-items (merge adapted-api-menu-items default-menu-items)]
    (into {} all-menu-items)))

(defn menu-raw->menu-db-data [menu-raw]
  (menu-items-map menu-raw))
